module.exports = __webpack_public_path__ + "img/DW365-293.0fc7a70f.jpg";